<template>
  <main class="main">
    <v-row>
      <v-col cols="12" md="6" style="background-color: #f5f5f5">
        <v-card class="pa-5" shaped>
          <v-row>
            <v-col>
              <v-autocomplete v-model="editedItem.idestablecimiento" :items="getEstablecimientosActivas"
                item-text="nombrecomercial" item-value="idestablecimiento" outlined dense @change="setIdEstablecimiento"
                label="Seleccione Establecimiento"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <Carrito :productos="carrito"></Carrito>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row justify="center">
            <v-col class="text-right" v-show="carrito.length > 0">
              <h3>TOTAL: Q {{ sumatoria || 0.0 | redondear }}</h3>
              <p>Total Descuento: Q {{ totalDescuento || 0.0 }}</p>
              <v-btn class="ma-2" color="blue-grey darken-2" dark large
                @click="clearCarrito"><v-icon left>mdi-close</v-icon> VACIAR LISTA
              </v-btn>
              <v-btn class="ma-2" color="green" v-show="sumatoria > 0" @click="modalcliente = true" dark large><v-icon
                  class="mdi-24px" left>mdi-cash-multiple</v-icon>PAGAR Q
                {{ sumatoria || 0.0 | redondear }}</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- PANEL DE PRODUCTOS -->
      <v-col cols="12" md="6" style="background-color: #f5f5f5;">
        <v-expansion-panels  v-model="panel" multiple>

          <v-expansion-panel>
            <v-expansion-panel-header>Subir Cotización</v-expansion-panel-header>
            <v-expansion-panel-content>
              <CargarCotizaciones @setproductos="productosCotizacion"></CargarCotizaciones>

            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header><strong>Listado Productos</strong></v-expansion-panel-header>
            <v-expansion-panel-content style="padding: 0;">
              <TablaProductos @setdata="pusCarrito"></TablaProductos>

            </v-expansion-panel-content>
          </v-expansion-panel>

       </v-expansion-panels>
       
      </v-col>
    </v-row>
    <!-- Modal Seleccionar Cliente -->
    <v-dialog v-model="modalcliente" persistent width="700">
      <v-card>
        <v-card-title class="headline blue text-white">
          <v-icon color="white mdi-24px">mdi-account-circle</v-icon>
          <v-divider class="mx-4" vertical></v-divider>
          Datos Comprobante
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="7">
              <DatosCliente @setcliente="setCliente">
              </DatosCliente>
            </v-col>
            <v-col cols="12" md="5">
              <DatosFactura ref="datosfactura" @setdocumento="setComprobante"></DatosFactura>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-2" @click="modalcliente = false" dark> <v-icon
              left>mdi-keyboard-backspace</v-icon> Volver</v-btn>
          <v-btn class="text-white" color="green" @click="postVenta">
            GENERAR
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <DialogProgress :procesando="procesardatos" :message="mensaje"></DialogProgress>

    <v-dialog v-model="dialogSizePaper" width="500">
      <TamanioDocumento :documento="documento" @opendialog="opendialog" />
    </v-dialog>
  </main>
</template>

<script>
import currency from "@/utils/currency.js";
import {setStorageCarrito,getStorageCarrito,clearStorageCarrito} from "../POS/utils/localstorage";
import generateXML from "@/utils/xmlFel.js";
import Swal from "sweetalert2";
import axios from "axios";
import { mapGetters } from "vuex";
//import dayjs from "dayjs";
import DialogProgress from "../shared/DialogProgress.vue";
import TamanioDocumento from "../Ventas/TamanioDocumento.vue";
import CargarCotizaciones from "../CargarCotizaciones/CargarCotizacion.vue"

import DatosFactura from "../POS/DatosFactura.vue";
import DatosCliente from "../POS/DatosCliente.vue";
import TablaProductos from "../POS/TablaProductos.vue";
import Carrito from "../POS/Carrito.vue";

export default {
  components: {
    TamanioDocumento,
    DatosCliente,
    DatosFactura,
    TablaProductos,
    DialogProgress,
    Carrito,
    CargarCotizaciones
  },
  name: "PuntodeVenta",
  data() {
    return {
      panel: [1],
      procesardatos: false,
      mensaje:'Procesando Datos...',
      documento: {},
      modalcliente: false,
      dialogSizePaper: false,

      
      carrito: [],
      cliente:'',
      establecimiento:'',
      carritoObj: {
        cantidad: 1,
        preciocompra: 0,
        descuento: 0,
        precioventa: 0,
        total: 0,
        idarticulo: 1,
      },
      cleancarritoObj: {
        cantidad: 1,
        preciocompra: 0,
        descuento: 0,
        precioventa: 0,
        total: 0,
        idarticulo: 1,
      },
      editedItem: {
        idusuario: 1,
        codigo:'',
        //fecha: dayjs().format("YYYY-MM-DD H:mm:ss"), //12:30:05
        descuento: 0,
        total: 0,
        idestablecimiento: 1,
        detallefactura: [],
      },
      defaultItem: {
        idusuario: 1,
        codigo:'',
        descuento: 0,
        total: 0,
        documento: "Factura Electrónica",
        //fecha: dayjs().format("YYYY-MM-DD H:mm:ss"),
        idestablecimiento: 1,
        detallefactura: [],
      },
      idfactura: false,
    };
  },
  async created() {
    
    await this.initialize();
  },
  computed: {
    ...mapGetters(["getTokenUser","getEstablecimientosActivas","getUrlPdf","getUrlApi"]),
    
    sumatoria() {
      return currency(
        this.carrito.reduce(
          (total, current) =>
            total +
            (current.cantidad * current.precioventa - current.descuento),
          0
        ),
        { precision: 5 }
      );
    },
    totalDescuento() {
      return currency(
        this.carrito.reduce(
          (descuento, current) => descuento + parseFloat(current.descuento),
          0
        )
      );
    },
  },
  methods: {
    
    async setIdEstablecimiento() {
     
      localStorage.setItem("idestablecimiento",this.editedItem.idestablecimiento);
      await this.$store.dispatch("setExistencias",this.editedItem.idestablecimiento);
      this.clearCarrito()
    },
    async initialize() {

      await this.$store.dispatch("setAllEstablecimientos");
      this.editedItem.idestablecimiento = parseInt( localStorage.getItem("idestablecimiento") )
      await this.$store.dispatch("setExistencias",this.editedItem.idestablecimiento);


      await this.$store.dispatch("setAllVentas");
      this.$store.dispatch("setNavigation");
     this.carrito = getStorageCarrito()
    },
    setCliente(data){
      //this.documento.idpersona = this.editedItemCliente;
      this.editedItem = Object.assign(this.editedItem, data);
      this.cliente = data;
    },
    clearCarrito(){
      this.carrito.splice(0, this.carrito.length)
      clearStorageCarrito()
    },
    setComprobante(data){
      this.editedItem = Object.assign(this.editedItem, data);
    },
    async opendialog() {

      const { data } = await axios.get(`${this.getUrlApi}/facturas/${this.idfactura}`,this.getTokenUser);
      // const establecimiento = this.getEstablecimientosActivas.find(
      //   (element) =>
      //     element.idestablecimiento == this.editedItem.idestablecimiento
      // );

      // this.documento = this.editedItem;
      // this.documento.idpersona = this.cliente
      // this.documento.idpersona.nombre = this.cliente.cliente;
      // this.documento.idfactura = this.idfactura;
      // this.documento.idestablecimiento = establecimiento;
      
      this.documento = data[0]

      await this.$store.dispatch('setdatatoprint',this.documento) 
    
      this.dialogSizePaper = !this.dialogSizePaper;
    },
    async postVenta() {
      
      if (!this.procesardatos) {
        this.editedItem.total = this.sumatoria;
        this.procesardatos = true;
        //DATOS FEL
        if (this.editedItem.documento === "Factura Electrónica") {
          const establecimiento = this.getEstablecimientosActivas.find(
            (element) =>
              element.idestablecimiento == this.editedItem.idestablecimiento
          );

          this.mensaje = 'Generando XML de Factura Electrónica'
          let felgenerado = await generateXML(
            establecimiento,
            this.cliente,
            this.carrito,
            this.editedItem
          );

 
          await this.validarDTE(felgenerado);
          //FIN DATOS FEL
        } else {
          //Post Crear Venta
          await this.createVenta();
        }
      }
    },
    async validarDTE(xmldte) {
      this.mensaje = 'Enviando Datos al Certificador, Validando DTE'
      const establecimiento = this.getEstablecimientosActivas.find(
        (element) =>
          element.idestablecimiento == this.editedItem.idestablecimiento
      );
      const data = {nit:establecimiento.nit,xmldte,token:establecimiento.token}
      try {
        
        this.mensaje = 'CERTIFICANDO DTE' 
        const factura = await axios.post(`${this.getUrlApi}/digifact/certificardte`,data)
        //const factura = await axios.post(`/fel/felSAT.php?op=validarFel`,{ xmlfel: xmldte, establecimiento: establecimiento });

      if (factura.data.Codigo == 1){
        this.editedItem.numero = parseInt(factura.data.NUMERO);
        this.editedItem.serie = factura.data.Serie;
        this.editedItem.autorizacion = factura.data.Autorizacion;
        await this.createVenta();

      }else{
        console.log('Error Log...',factura)
        this.errorSwal(factura.Mesaje);
        this.procesardatos = false;
        this.modalcliente = false;
      }
        //Post Crear Venta
      } catch (error) {
        console.log(error)
        this.mensaje = 'Existio Error al Procesar Documento'
        this.procesardatos = false;
        this.modalcliente = false;
        this.errorSwal(error.msg);
      }
      
    },
    async createVenta() {
      //POST VENTA
      
      this.editedItem.detallefactura = this.carrito;
      this.mensaje = 'Guardando Información del Documento'
      try {
        const { data } = await this.$store.dispatch(
          "createVenta",
          this.editedItem
        );
        this.editedItem.estado = data.estado
        this.idfactura = data.idfactura;
        this.createDetalleVenta();
      } catch (error) {
        this.procesardatos = false;
        console.log(error);
        this.errorSwal("Error al registrar la venta");
      }
    },
    async createDetalleVenta() {
      this.mensaje = 'Guardando productos/servicios en el sistema...'
      const carrito = [];
      this.carrito.forEach((item) => {
        item.idfactura = this.idfactura;
        carrito.push(item);
      });

      
      
      try {
        await axios.post(
          `${this.getUrlApi}/facturadetalles/`,
          carrito,
          this.getTokenUser
        );
        this.procesardatos = false;
        this.mensaje = ''
        this.opendialog();
        this.modalcliente = false;
      } catch (error) {
        this.procesardatos = false;
        this.mensaje = ''
        this.errorSwal("Error al generar documento");
      }

      //Actualizamos el stock si es una factura ó Recibo
      if (this.editedItem.documento != "Proforma") {
        const params = {idfactura: this.idfactura,idestablecimiento:this.editedItem.idestablecimiento}
        await this.$store.dispatch("decrementStock", params);
        
      }
      await this.$store.dispatch("setAllVentas");
      await this.$store.dispatch("setExistencias",this.editedItem.idestablecimiento);
      
      this.clearData();
      
    },
    clearData() {
      this.mensaje = ''
      //this.editedItem = Object.assign({}, this.defaultItem);
      this.$refs.datosfactura.buscarVentaPorTipo() //Ejecutamos el metodo buscarVentaporTipo del componente DatosFactura
      this.carrito = [];
      clearStorageCarrito()
    },

    //Insertamos los productos cargados en la cotizacion xls
    productosCotizacion(prod){
      console.log(prod)
      this.carrito = prod;
    },

    //METODOS PARA AGREGAR Y ELIMINAR ELEMENTOS DEL CARRITO
    pusCarrito(item) {
      
      const articulo = this.carrito.find(
        (elemento) => elemento.idarticulo == item.articulo.idarticulo
      );

      //Si es diferente de vacio que inserte el producto
      if (!articulo) {
        this.carritoObj.nombre = item.articulo.nombre;
        this.carritoObj.cantidad = parseFloat(1);
        this.carritoObj.preciocompra = item.articulo.preciocompra;
        this.carritoObj.descuento = parseFloat(0.0);
        this.carritoObj.precioventa = parseFloat(item.articulo.preciosugerido);
        this.carritoObj.total =
          this.carritoObj.cantidad * this.carritoObj.precioventa;
        this.carritoObj.idarticulo = parseInt(item.articulo.idarticulo);
        this.carrito.push(this.carritoObj);
        setStorageCarrito(this.carrito)
      } else {
        this.addItemCart(articulo, item);
        
      }
      this.carritoObj = Object.assign({}, this.cleancarritoObj);
    },
    addItemCart(articulo, item) {
      if (item.articulo.controlstock) {
        if (item.stockactual > articulo.cantidad) {
          articulo.cantidad++;
          articulo.total = articulo.cantidad * articulo.precioventa;
          //item.stockactual--
          setStorageCarrito(this.carrito)
        } else {
          Swal.fire("Cantidad supera a las existencias");
        }
      }
    },
    

    //Notificaciones Swal
    alertDone(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    errorSwal(message) {
      Swal.fire({
        icon: "error",
        title: message,
        text: "El documento no pudo ser procesado intentelo mas tarde",
      });
    },
    infoSwal(message, texto) {
      Swal.fire({
        icon: "info",
        title: message,
        text: texto,
      });
    },
  },
  filters: {
    redondear: function (value) {
      if (!value) return "";
      value = parseFloat(value);
      return currency(value, { precision: 2 });
    },
  },
};
</script>
<style scoped>
.main {
  margin-top: -10px;
  height: 100vh;
}
</style>